import classNames from "classnames";
import { Link } from "react-router-dom";
import { RiotLogo } from "@ugitgud/legos/components/home-page/icons/RiotLogo";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import { SvgMiscPaperWriting } from "@ugitgud/legos/ui/icon/SVG/MiscPaperWriting";

interface PlusTierListCTAPageProps {
  className?: string;
}

export function PlusTierListCTAPage({ className }: PlusTierListCTAPageProps) {
  return (
    <div
      className={classNames(
        "flex flex-row xs:flex-col-reverse md:flex-row items-center gap-[46px] justify-between max-w-[1016px] w-full mx-auto px-3 lg:px-0 xs:h-auto",
        className,
      )}
    >
      <div className="flex flex-col shrink-0 max-w-[366px]">
        <div className="flex items-center gap-[11.84px] mb-9">
          <span className="rounded-[3px] text-[14.422px] font-semibold border border-accent-yellow-400 px-[4.36px] py-[3.4px] bg-accent-brown-400 text-accent-yellow-400">
            PLUS
          </span>
          <span className="text-white text-[24px] font-bold">Exclusive Feature</span>
        </div>

        <div className="flex items-center gap-3 mb-3">
          <div className="flex items-center justify-center bg-purple-400 rounded-[3px] w-[26px] h-[26px]">
            <SvgMiscPaperWriting className="w-[15px] h-[15px] text-accent-yellow-400" />
          </div>
          <h2 className="text-[36px] font-bold text-white leading-tight">Personal Tier List</h2>
        </div>

        <p className="text-lavender-50 text-[18px] font-normal mb-6 leading-snug">
          A dedicated tier list page on your profile displaying your best champions.
        </p>

        <div className="flex items-center gap-5 mb-4.5">
          <Link
            to={`${AppRoutes.CHECKOUT}?plan=12-month`}
            className="group relative flex items-center justify-center rounded-[3px] h-9 w-[150px] bg-accent-brown-400 border border-accent-yellow-400 text-white text-[14px] font-semibold transition-all"
          >
            <span
              className="absolute inset-0 rounded-[3px] opacity-0 group-hover:opacity-100 transition-opacity"
              style={{
                background: "linear-gradient(0deg, rgba(244, 200, 116, 0.05) 0%, rgba(244, 200, 116, 0.05) 100%), #25254B",
              }}
            />
            <span className="relative">
              Try for&nbsp;<span className="text-accent-yellow-400 font-bold">Free</span>
            </span>
          </Link>
          <Link
            to={`${AppRoutes.PLUS}#features`}
            className="flex text-[14px] font-semibold items-center justify-center rounded-[3px] h-9 w-[150px] text-white bg-lavender-500 hover:bg-lavender-400 transition-colors whitespace-nowrap shrink-0"
          >
            See all features
          </Link>
        </div>

        <div className="flex items-center gap-2 text-[12px] font-normal text-accent-gray-200">
          <RiotLogo className="w-6 h-6 fill-accent-gray-200" />
          Fully compliant with Riot Games
        </div>
      </div>

      <img
        src="https://static.bigbrain.gg/assets/ugg/cta/personal-tierlist.png"
        alt=""
        className="hidden xs:block xs:w-full xs:h-auto md:w-[602px] md:h-[339px] md:shrink-0 object-cover"
      />
    </div>
  );
}
